export default __webpack_public_path__ + "static/index-header-b73070717dc935fb6bc6356c8c10ed7a.jpg";